import { DragOverlay } from '@dnd-kit/react';
import { getFileExtension } from '@repo/lib/fs/getFileExtension';

import { useFsDragDropContext } from '@/components/features/files/dnd';
import { Badge } from '@/components/ui/badge';
import { FileIcon, FolderIcon } from '@/components/ui/file-icon';
import { FS_DRAG_TYPE } from '@/hooks/fs/useFsDragDrop';
import { useFilesStorage } from '@/store/files-store';

/**
 * Overlay component that renders a preview of the dragged item(s).
 * Shows either a single item or a count badge when multiple items are selected.
 */
export function FsDragOverlay() {
  const { draggedItem, isDragging } = useFsDragDropContext();
  const { selected } = useFilesStorage();

  if (!isDragging || !draggedItem) {
    return null;
  }

  // Check if the dragged item is part of a multi-selection
  const isMultiSelection: boolean = selected.files.length + selected.directories.length > 1;

  const isDraggedItemSelected: boolean =
    draggedItem.type === FS_DRAG_TYPE.FILE ? selected.files.some((f) => f.id === draggedItem.entity.id) : selected.directories.some((d) => d.id === draggedItem.entity.id);

  const showMultiDrag: boolean = isMultiSelection && isDraggedItemSelected;
  const totalItems: number = selected.files.length + selected.directories.length;

  const isFile: boolean = draggedItem.type === FS_DRAG_TYPE.FILE;
  const entityName: string = draggedItem.entity.name;

  return (
    <DragOverlay>
      <div className="pointer-none border-border-primary bg-background flex max-w-sm items-center gap-2 rounded-md border p-1 shadow-lg">
        {isFile ? <FileIcon fileExtension={getFileExtension(entityName)} /> : <FolderIcon />}

        <span className="text-foreground truncate text-sm">{entityName}</span>

        {showMultiDrag && (
          <Badge size={'sm'} variant={'muted'}>
            +{totalItems - 1}
          </Badge>
        )}
      </div>
    </DragOverlay>
  );
}
